module.exports = __webpack_public_path__ + "static/media/amine4.28a8d2f0.webp";